module.exports = __webpack_public_path__ + "static/media/campus_13.e38b00b0.jpeg";